import React, {useState} from 'react'
import {Formik, Form, Field} from 'formik'
import {useNavigate} from 'react-router-dom'
import {KTIcon} from '@/_metronic/helpers'
import {useListView} from '@/components/table/core/ListViewProvider'
import {FormActions} from '@/components/form/Actions'
import {Product} from '../../core/_models'
import {copyProduct} from '../../core/_requests'

const CopyForm = () => {
  const navigate = useNavigate()
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()
  const [error, setError] = useState<string | undefined>()
  const product = itemForUpdate as Product

  const close = () => {
    setItemForUpdate(undefined)
    setAction(undefined)
  }

  return (
    <>
      {error && (
        <div className="alert alert-warning d-flex align-items-center p-5 mb-10">
          <KTIcon iconName="information" className="fs-5x me-4 text-warning" />

          <div className="d-flex flex-column">
            <h5 className="mb-1">{error}</h5>
            <span>An error happened copying this product!</span>
          </div>
        </div>
      )}

      <Formik
        initialValues={{}}
        onSubmit={async () => {
          try {
            const copy = await copyProduct(itemForUpdate?._id)
            close()
            navigate(`/p2c/product/${copy?._id}/overview`)
          } catch (e: any) {
            setError(e?.response?.statusText)
          }
        }}
      >
        {() => (
          <Form id="product-status" className='form'>
            <div className="alert alert-danger border border-danger border-3 border-dashed d-flex align-items-center p-5 d-flex flex-center flex-column">
              <div className="d-flex flex-column">
                <h5 className="mb-1">
                  Are you sure to create a copy of {product.name} (#{product.sku}) ?
                </h5>
              </div>
            </div>

            <Field
              component={FormActions}
              close={close}
            />
          </Form>
        )}
      </Formik>
    </>
  )
}

export {CopyForm}
